import Vue from 'vue'
import App from './App.vue'
import {
  ModalPlugin, ToastPlugin,
  LayoutPlugin, CardPlugin,
  TablePlugin, PaginationPlugin,
  ButtonPlugin, ButtonGroupPlugin,
  FormPlugin, InputGroupPlugin, FormInputPlugin,
  FormGroupPlugin, FormRadioPlugin, FormCheckboxPlugin,
  FormSelectPlugin, SkeletonPlugin,
  BadgePlugin, SpinnerPlugin,
  BFormInvalidFeedback,
  CollapsePlugin,BootstrapVueIcons,
  BootstrapVue 
} from 'bootstrap-vue'
import './assets/css/adminlte.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'jquery-ui-dist/jquery-ui.min.css'
import 'overlayscrollbars/css/OverlayScrollbars.min.css'

import 'expose-loader?$!expose-loader?jQuery!jquery'
import 'jquery-ui-dist/jquery-ui.min'
import 'bootstrap'
import 'overlayscrollbars/js/jquery.overlayScrollbars.min'
import 'admin-lte'
import '@/assets/css/utilities.css'
import router from './router'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import ContentWrapper from "@/components/Layouts/ContentWrapper";
import ContentHeader from "@/components/Layouts/ContentHeader";
import Content from "@/components/Layouts/Content";

// 3rd party plugins
import '@axios';

//VueX Store
import store from './store';
import Acl from './libs/acl';

import 'bootstrap-icons/font/bootstrap-icons.css'
// Axios Mock Adapter
// import '@/@fake-db/db'

//Chart
import VueApexCharts from 'vue-apexcharts';

import vSelect from "vue-select";

Vue.config.productionTip = false

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(LayoutPlugin)
Vue.use(CardPlugin)
Vue.use(TablePlugin)
Vue.use(PaginationPlugin)
Vue.use(BadgePlugin)
// VueBootstrap Form
Vue.use(BootstrapVueIcons)
Vue.use(ButtonPlugin)
Vue.use(FormRadioPlugin)
Vue.use(ButtonGroupPlugin)
Vue.use(FormPlugin)
Vue.use(InputGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormSelectPlugin)
Vue.use(SkeletonPlugin)
Vue.use(SpinnerPlugin)
Vue.use(CollapsePlugin)
Vue.use(FormCheckboxPlugin)
// Other
Vue.use(BootstrapVue)
Vue.use(VueApexCharts);

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

Vue.filter('cut', function(text, stop, clamp) {
  return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
})

Vue.filter('uppercase', function (text) {
  return text.toUpperCase()
})

Vue.filter('clean_date', function(text) {
  return text.replace(/1970-01-01\+07:00|\+07:00/, '')
})

Vue.filter('direction_text', function(text) {
  return text === 1 ? 'IN' : ( text === 2 ? 'OUT' : '-' )
})

Vue.filter('clean_timestamp', function(text) {
  if( text instanceof String )
    return text.replace(/T/, ' ').slice(0,19);
  return text;
})

Vue.directive('uppercase', {
  update(el) {
    const orig = el.value;
    if ( orig === undefined )
      return;
    const resp = orig.toUpperCase();

    if (orig !== resp) {
      el.value = resp;
      el.dispatchEvent(new Event('input', {bubbles: true}));
    }
  },
});

Vue.component("v-select", vSelect);
Vue.component('apexchart', VueApexCharts);
Vue.component('content-wrapper', ContentWrapper);
Vue.component('content-header', ContentHeader);
Vue.component('Content', Content);
Vue.component('b-form-invalid-feedback', BFormInvalidFeedback);
Vue.use(Acl)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
